if (!customElements.get('scroll-next')) {
    class ScrollNext extends HTMLElement {
        connectedCallback() {
            const btn = this.querySelector('.banner__next-section-button');

            if (!btn) return;

            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const section = this.closest('section');
                if (!section) return;

                const next = section.nextElementSibling;
                if (!next) return;

                next.scrollIntoView({ behavior: 'smooth' });
            });
        }
    }

    customElements.define('scroll-next', ScrollNext);
}
